import { gql } from "utils/urql";
import { forwardRef } from "react";
import { ArticlePullquoteFragment } from "types/api";
import styles from "./ArticlePullquote.module.scss";

const ArticlePullquote = forwardRef<HTMLElement, ArticlePullquoteFragment>(
  function ArticlePullquote({ idAttr, innerHtml }, ref) {
    return (
      <aside
        ref={ref}
        id={idAttr || undefined}
        className={styles.root}
        dangerouslySetInnerHTML={{ __html: innerHtml }}
      />
    );
  }
);

export default ArticlePullquote;

ArticlePullquote.fragment = gql`
  fragment articlePullquote on ArticlePullquote {
    idAttr
    innerHtml
  }
`;
